<template>
  <svg width="100%" height="100%" viewBox="0 0 260 260" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <g transform="matrix(-2.11667,0,0,2.11667,553.332,-505.233)">
      <g transform="matrix(1.45311,0,0,1.45193,-21.1367,-162.739)">
        <path :style="{ fill: primary }"
              d="M191.035,316.342C192.381,317.689 192.381,319.873 191.035,321.221C183.276,328.985 159.659,352.622 159.659,352.622L159.659,342.209C159.659,342.209 177.671,324.183 182.095,319.755C182.632,319.217 182.632,318.346 182.095,317.808C176.986,312.694 153.482,289.171 153.482,289.171L153.482,278.759C153.482,278.759 182.357,307.658 191.035,316.342Z"
        />
      </g>
      <g transform="matrix(1,0,0,1,0,-210)">
        <path :style="{ fill: secondary }"
              d="M198.11,467.118C198.11,467.118 164.649,500.579 156.766,508.461C155.856,509.372 155.856,510.849 156.766,511.759C164.042,519.035 192.913,547.906 192.913,547.906L192.913,528.063L199.999,535.15C199.999,535.15 221.652,513.497 224.687,510.462C224.881,510.268 224.881,509.953 224.687,509.759C221.652,506.724 199.999,485.071 199.999,485.071C199.999,485.071 178.286,506.784 175.299,509.771C175.209,509.861 175.159,509.983 175.159,510.11C175.159,510.237 175.209,510.359 175.299,510.449C177.452,512.603 189.133,524.283 189.133,524.283L189.133,537.039C189.133,537.039 167.495,515.401 163.011,510.917C162.565,510.471 162.562,509.747 163.006,509.298C168.47,503.766 199.999,471.843 199.999,471.843C199.999,471.843 232.638,503.694 238.361,509.279C238.585,509.498 238.712,509.798 238.712,510.111C238.713,510.425 238.588,510.725 238.365,510.945C233.285,515.95 207.086,541.764 207.086,541.764L207.086,563.024L199.999,570.11C199.999,570.11 156.412,526.523 143.538,513.649C141.584,511.695 141.584,508.526 143.538,506.571C156.145,493.965 198.11,452 198.11,452L198.11,467.118Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'BrandIcon',

  props: {
    primary: {
      type: String,
      default: 'rgb(214,0,0)'
    },

    secondary: {
      type: String,
      default: 'rgb(40,40,40)'
    }
  }
}
</script>
